import { Button } from "@/components/ui/button";
import { useGetCards } from "@/hooks/use-queries";
import { useModalStore } from "@/zustand/modalStore";
import { useState } from "react";

const Transfer2Card = ({ closeSheet }) => {
  const { data: cards, isLoading: cardIsLoading } = useGetCards();
  const [selectedCard, setSelectedCard] = useState<Card | null>(null);
  const { openModal } = useModalStore();

  return (
    <div className="mt-4 px-2 text-white">
      <h2 className="font-semibold">Top Up to Card</h2>

      <div className="mt-4">
        <h4 className="text-sm">Select card you want to Top Up</h4>
        {cardIsLoading ? (
          <div className="relative mt-6 flex flex-col gap-4">
            {[1, 2, 3].map((index) => (
              <CardSkeleton key={index} />
            ))}
          </div>
        ) : cards?.data.length > 0 ? (
          <div>
            <div className="mt-6 flex flex-col gap-4">
              {cards?.data.map((card: Card) => (
                <Card
                  selectedCard={selectedCard}
                  setSelectedCard={setSelectedCard}
                  cardData={card}
                  key={card.id}
                />
              ))}
            </div>
            <div className="mt-6">
              <Button
                disabled={!selectedCard}
                onClick={() => {
                  closeSheet();
                  openModal("fundCard", { cardData: selectedCard });
                }}
                className="text-primary-500 bg-primary-100 h-10 w-full hover:bg-[#B0D4F0`]"
              >
                Proceed
              </Button>
            </div>
          </div>
        ) : (
          <div className="w- flex h-100 items-center justify-center">
            <div className="flex flex-col text-center">
              <h2 className="text-2xl font-bold">No Cards</h2>
              <p className="text-primary-500/40">
                Instantly create a card to start making transactions
              </p>

              {/* <div className="mt-4">
                <Button
                  className="w-full"
                  type="submit"
                  onClick={() => {
                    navigate("/dashboard/shop/virtual-cards");
                  }}
                >
                  Create Card
                </Button>
              </div> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Transfer2Card;

const CardSkeleton = () => {
  return (
    <div className="h-18 w-full max-w-lg animate-pulse overflow-hidden rounded-xl bg-gray-700 shadow-[rgba(0,_0,_0,_0.25)_0px_25px_50px_-12px]"></div>
  );
};

const Card = ({
  cardData,
  selectedCard,
  setSelectedCard,
}: {
  cardData: Card;
  selectedCard: Card | null;
  setSelectedCard: (card: Card) => void;
}) => {
  const isActive = selectedCard?.id === cardData.id;
  return (
    <div
      role="button"
      onClick={() => setSelectedCard(cardData)}
      tabIndex={0}
      className={`relative overflow-hidden rounded-xl border border-[#DAE1EA1A] p-4 transition-all hover:cursor-pointer active:scale-x-98 ${
        isActive ? "" : "opacity-50"
      }`}
      style={{
        background:
          "linear-gradient(108.57deg, #B9D2E2 -4.61%, #756C95 97.89%)",
      }}
    >
      <div className="absolute inset-0 z-0 bg-[#6060600D] backdrop-blur-sm" />
      <img
        className="absolute right-0 bottom-0 w-30"
        src="/images/card-lines.svg"
        alt=""
      />
      <img
        className="absolute bottom-0 left-0 h-full"
        src="/images/card-blur2.svg"
        alt=""
      />
      {isActive && (
        <div className="bg-primary-100 absolute top-2 right-2 size-3 rounded-full" />
      )}
      <div className="relative flex h-full w-full items-center justify-between">
        <div>
          <p>**** **** **** {cardData.last4}</p>
          <p className="text-[10px]">
            {cardData.firstName} {cardData.lastName}
          </p>
        </div>
        {cardData.network === "VISA" ? (
          <img className="w-14" src="/images/visa.svg" alt="" />
        ) : (
          <img className="w-14" src="/images/mastercard-logo.svg" alt="" />
        )}
      </div>
    </div>
  );
};
